import { GetOffice_Out } from 'src/pehra-ts-client';
import styles from './OfficeItem.module.css';
import { Box, Button, Typography } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';

export interface IOfficeItem {
  office: GetOffice_Out;
  isSelected: boolean;
}

const OfficeItem: React.FC<IOfficeItem> = ({ office, isSelected }) => {
  return (
    <Box
      sx={{
        office: 'relative'
      }}
    >
      {/* display a folder icon */}
      <Box className={styles.folderIconDiv}>
        <FolderIcon className={styles.folderIcon} />
        <Typography variant="h5" className={styles.folderIconText}>
          {office.office_name}
        </Typography>
      </Box>

      {isSelected && (
        <Box
          sx={{
            position: 'absolute',
            bottom: '18',
            left: '0',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            marginTop: '10px'
          }}
        >
          <Button variant="contained" color="primary">
            Open
          </Button>
          <Button variant="contained" color="primary">
            Move
          </Button>
          <Button variant="contained" color="primary">
            Delete
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default OfficeItem;
